import { render, staticRenderFns } from "./Recipes.vue?vue&type=template&id=5fd14484&"
import script from "./Recipes.vue?vue&type=script&lang=js&"
export * from "./Recipes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports